import { createReducer, on } from '@ngrx/store';
import { ActivityRecordVerificationStatus } from '../../data-model/enums/activity-record-verification-status.enum';
import { getNulledOutActivitySummaryFilter } from '../../data-model/models/activity-summary-filter.model';
import { ActivityActions } from '../actions';
import { ActivityState } from '../state/activity.state';

export const initialActivityState: ActivityState = {
  activityRecords: [],
  filter: getNulledOutActivitySummaryFilter(),
  limit: 8,
  numberOfActivityRecords: 0,
  numberOfMissingActivityRecords: 0,
  offset: 0,
  verificationStatus: ActivityRecordVerificationStatus.ACTIVITY,
};

export const activityReducer = createReducer(
  initialActivityState,
  on(
    ActivityActions.activityRecordsLoaded,
    (state, action): ActivityState => ({ ...state, activityRecords: action.activityRecords, numberOfActivityRecords: action.numberOfActivityRecords })
  ),
  on(
    ActivityActions.setVerificationStatus,
    (state, action): ActivityState => ({
      ...state,
      activityRecords: initialActivityState.activityRecords,
      numberOfActivityRecords: initialActivityState.numberOfActivityRecords,
      verificationStatus: action.verificationStatus,
      limit: initialActivityState.limit,
      offset: initialActivityState.offset,
      filter: initialActivityState.filter,
    })
  ),
  on(ActivityActions.setLimit, (state, action): ActivityState => ({ ...state, limit: action.limit })),
  on(ActivityActions.setOffset, (state, action): ActivityState => ({ ...state, offset: action.offset })),
  on(ActivityActions.setFilter, (state, action): ActivityState => ({ ...state, filter: action.filter })),
  on(
    ActivityActions.missingActivityRecordsLoaded,
    (state, action): ActivityState => ({ ...state, numberOfMissingActivityRecords: action.numberOfMissingActivityRecords })
  ),
  on(ActivityActions.resetActivityState, (state): ActivityState => ({ ...state, ...initialActivityState }))
);
